// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ds-simple-card-container{border:1px solid var(--section-border-color);border-radius:8px;padding:33px 42px}.ds-simple-card-container.shadow{box-shadow:0px 2px 6px rgba(0,0,0,.06)}.ds-simple-card-container.hoverable:hover{border-color:var(--primary-color)}.ds-simple-card-container.secondary{padding:32px;border:1px solid var(--gray-2)}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
